import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccEntrepreneur } from '../acc-entrepreneurs-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccEntrepreneur, unknown>[] = [
		buildColumn(util, 'Id', row => row.accEntrepreneurId, { header: 'accEntrepreneurId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId', sort: { order: 2, dir: 'asc' } }),
		buildColumn(util, 'Id', row => row.accTeamId, { header: 'accTeamId', sort: { order: 1, dir: 'asc' } }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastAutoEmailDeliveredUTC), { header: 'Last Auto Email Date', hidden: true }),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture' }),
		buildColumn(util, 'Text', row => row.ventureStatus, { header: 'Status', group: 'desc' }),
		buildColumn(util, 'Text', row => row.teamName, { header: 'Team' }),
		buildColumn(util, 'FirstName', row => row.firstName, { header: 'First Name', hidden: true }),
		buildColumn(util, 'LastName', row => row.lastName, { header: 'Last Name', hidden: true }),
		buildColumn(util, 'Phone', row => row.phone, { header: 'Phone', hidden: true }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email', hidden: true }),
		buildColumn(util, 'Text', row => row.cityAndState, { header: 'Location' }),
		buildColumn(util, 'Number', row => row.zip, { header: 'Zip Code', hidden: true }),
		buildColumn(util, 'Text', row => row.handbookSigned ? 'Signed' : 'Not Signed', { header: 'Handbook', hidden: true }),
		buildColumn(util, 'Text', row => row.mediaConsentSigned ? 'Signed' : 'Not Signed', { header: 'Media Consent', hidden: true }),
		buildColumn(util, 'YesNo', row => row.isClassSpeaker, { header: 'Class Speaker', hidden: true }),
		buildColumn(util, 'Number', row => row.absences, { header: 'Absences' }),
		buildColumn(util, 'Percent', row => Math.round(row.eLearningScore ?? 0), { header: 'eLearning Score', hidden: true }),
		buildColumn(util, 'Percent', row => Math.round(row.attendanceScore ?? 0), { header: 'Attendance Score', hidden: true }),
		buildColumn(util, 'Percent', row => Math.round(row.surveyScore ?? 0), { header: 'Survey Score', hidden: true }),
	];


	return columns;

}